import { useEffect } from 'react'
import { ArrowKeyDirection } from '@/interfaces'

const keyCodes: { [x: string]: string } = {
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
}

export default function useArrowNavigation(callback: (event: KeyboardEvent, direction: ArrowKeyDirection) => void) {
  useEffect(() => {
    function handleKeyPressed(event: KeyboardEvent) {
      if (keyCodes[event.keyCode] !== undefined) {
        callback(event, keyCodes[event.keyCode] as ArrowKeyDirection)
      }
    }

    // Bind the event listener
    document.addEventListener('keydown', handleKeyPressed)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('keydown', handleKeyPressed)
    }
  }, [callback])
}
